<script setup>
import { ViewFileProps } from "./config";
import { defineProps, computed, watch, ref } from "vue";
import UtilFile from "@/framework/Utils/UtilFile";
import ViewWord from "./ViewWord/ViewWord.vue";

const props = defineProps(ViewFileProps);

const txtString = ref("");
const BASE_URL = ref(process.env.BASE_URL);

const fileUrl = computed(() => {
  if (props.url) {
    return props.url;
  }
  return UtilFile.BlobToURL(props.stream, props.type);
});

const fileBlob = computed(() => {
  if (props.stream) {
    return props.stream;
  }
  return UtilFile.URLToBlob(props.url);
});

const isImg = computed(() => {
  const typeArr = ["jpg", "jpeg", "png", "gif", "bmp"];
  return typeArr.includes(props.type);
});

const isWord = computed(() => {
  const typeArr = ["docx"];
  return typeArr.includes(props.type);
});

watch(
  () => props.type,
  () => {
    if (props.type === "txt" && fileBlob) {
      let reader = new FileReader();
      // 传入需要被转换的文本流 file,这个是转字符串的关键方法
      reader.readAsText(fileBlob.value);
      // onload是异步的,封装的话可以用promise
      reader.onload = () => {
        // 输出字符串
        txtString.value = reader.result;
      };
    }
  }
);
</script>

<script>
export default {
  name: "ViewFile",
};
</script>

<template>
  <div class="pdf" v-if="props.type === 'pdf'">
    <iframe
      :src="`${BASE_URL}static/pdf/web/viewer.html?file=${encodeURIComponent(
        fileUrl
      )}`"
      width="100%"
    ></iframe>
  </div>
  <div class="img" v-if="isImg">
    <img :src="fileUrl" />
  </div>
  <div class="word" v-if="isWord">
    <ViewWord v-if="fileBlob" :stream="fileBlob" />
  </div>
  <div class="txt" v-if="props.type === 'txt'" v-html="txtString"></div>
</template>

<style scoped lang="scss">
.pdf {
  width: 100%;
  height: 100%;
  iframe {
    border: 0;
    height: calc(100% - 5px);
  }
}
.img {
  width: 100%;
  height: 100%;
  img {
    width: inherit;
    height: inherit;
  }
}
.word {
  width: 100%;
  min-height: 100%;
  height: auto;
}
.txt {
  font-size: 16px;
  padding: 5px;
  color: black;
}
</style>
